import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { DocumentTitle } from 'src/routes/components';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

// ----------------------------------------------------------------------

const BillingSuccessPage = lazy(() => import('src/pages/billing/success'));
const BillingPortalReturnPage = lazy(() => import('src/pages/billing/portal-return'));

// Shared elements — reused across both path patterns
const successElement = (
  <Suspense fallback={<SplashScreen />}>
    <>
      <DocumentTitle />
      <BillingSuccessPage />
    </>
  </Suspense>
);

const portalReturnElement = (
  <Suspense fallback={<SplashScreen />}>
    <>
      <DocumentTitle />
      <BillingPortalReturnPage />
    </>
  </Suspense>
);

export function getBillingRoutes(): RouteObject[] {
  return [
    // Standalone /billing/* paths (used in paths.ts)
    {
      path: 'billing',
      children: [
        { path: 'success', element: successElement },
        { path: 'portal-return', element: portalReturnElement },
      ],
    },
    // Backend sets Stripe success_url under /organization-settings/billing/*
    // These render the same standalone pages (no dashboard layout wrapper)
    {
      path: 'organization-settings/billing',
      children: [
        { path: 'success', element: successElement },
        { path: 'portal-return', element: portalReturnElement },
      ],
    },
  ];
}
